<template>
    <v-flex class="text-sm-right">
        <v-btn v-if="!getProfile" @click="goToLogin" round dark>{{ $t('Views.Search.access_to_services') }}</v-btn>

        <div v-else class="mt-3">
            <v-menu
                    bottom
                    left
                    content-class="dropdown-menu"
                    offset-y
                    transition="slide-y-transition">
                <v-icon slot="activator" class="toolbar-items">mdi-apps</v-icon>
                <v-card>
                    <v-list dense>
                        <v-list-tile v-if="getProfile.role === 'IT'">
                            <v-list-tile-title>
                                <a href="/dashboard/">
                                    <v-icon color="tertiary">mdi-view-dashboard</v-icon>
                                    <span style="color: black">&nbsp;Dashboard</span>
                                </a>
                            </v-list-tile-title>
                        </v-list-tile>
                        <v-list-tile v-if="getProfile.roleTds !== 'NOACCESS'">
                            <v-list-tile-title>
                                <a href="/tds/">
                                    <v-icon color="tertiary">mdi-file-document-outline</v-icon>
                                    <span style="color: black">&nbsp;T.D.S.</span>
                                </a>
                            </v-list-tile-title>
                        </v-list-tile>
                    </v-list>
                </v-card>
            </v-menu>

            <v-chip color="black" class="ml-4" text-color="white">
                {{ getProfile.username }}
                <v-menu bottom
                        left
                        content-class="dropdown-menu"
                        class="ml-2"
                        offset-y
                        transition="slide-y-transition">
                    <v-icon slot="activator" class="toolbar-items" color="white">mdi-account-circle</v-icon>
                    <v-card>
                        <v-list dense>
                            <v-list-tile>
                                <v-list-tile-title>
                                    <router-link
                                            v-ripple
                                            slot="activator"
                                            class="toolbar-items"
                                            to="/search">
                                        <v-icon color="tertiary">mdi-magnify</v-icon>
                                        <span style="color: black">&nbsp;{{ $t('Views.Search.product_search_title') }}</span>
                                    </router-link>
                                </v-list-tile-title>
                            </v-list-tile>
                            <v-list-tile>
                                <v-list-tile-title>
                                    <router-link
                                            v-ripple
                                            slot="activator"
                                            class="toolbar-items"
                                            to="/settings">
                                        <v-icon color="tertiary">mdi-settings</v-icon>
                                        <span style="color: black">&nbsp;{{ $t('Views.Settings.settings_title') }}</span>
                                    </router-link>
                                </v-list-tile-title>
                            </v-list-tile>
                            <v-list-tile>
                                <v-list-tile-title>
                                    <router-link
                                            v-ripple
                                            slot="activator"
                                            class="toolbar-items"
                                            to="/privacy">
                                        <v-icon color="tertiary">mdi-security</v-icon>
                                        <span style="color: black">&nbsp;{{ $t('Core.GDPR.privacy_title') }}</span>
                                    </router-link>
                                </v-list-tile-title>
                            </v-list-tile>
                            <v-list-tile @click="logout">
                                <v-list-tile-title>
                                    <v-icon color="tertiary">mdi-logout</v-icon>
                                    <span style="color: black">&nbsp;Logout</span>
                                </v-list-tile-title>
                            </v-list-tile>
                        </v-list>
                    </v-card>
                </v-menu>
            </v-chip>
        </div>
    </v-flex>
</template>

<script>
import {mapGetters} from 'vuex'

export default {
    methods: {
        goToLogin() {
            this.$router.push({name: 'Login'})
        },
        logout() {
            this.$store.dispatch('ACTION_LOGOUT')
            this.$router.push({name: 'Search'})
        }
    },
    computed: {
        ...mapGetters(['getProfile'])
    }
}
</script>

<style>

</style>
